document.addEventListener( 'DOMContentLoaded', () => {
	getCartAmount();
} );

export const getCartAmount = () => {
	const cartAmount = localStorage.getItem( "psh_cart_amount" );
	if ( cartAmount !== null ) {
		updateCartIcons( cartAmount );
	} else {
		fetchCartAmount();
	}
}

const updateCartIcons = ( amount ) => {
	const cartIcons = document.querySelectorAll( '.cart-icon' );

	if ( cartIcons.length === 0 ) {
		unsetLocalStorageCartAmount();
	}

	cartIcons.forEach( ( cartIcon ) => {
		if ( amount === '0' ) {
			cartIcon.removeAttribute( 'data-amount' );
		} else {
			cartIcon.setAttribute( 'data-amount', amount );
		}
	} );
}

const fetchCartAmount = () => {
	fetch( psh_vars.rest_route.psh_get_cart_amount )
		.then( response => response.json() )
		.then( data => {
			localStorage.setItem( "psh_cart_amount", data.cartIconAmount );
			updateCartIcons( data.cartIconAmount );
		} );
}

export const setLocalStorageCartAmount = ( amount ) => {
	if ( !isNaN( amount ) || typeof amount === 'string' ) {
		localStorage.setItem( "psh_cart_amount", amount );
		getCartAmount();
	}
}

export const unsetLocalStorageCartAmount = () => {
	localStorage.removeItem( "psh_cart_amount" );
}